import { Small } from 'foundations-components/transitional/components/Small';
import FormattedDate from '../sidebar/FormattedDate';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalUnifiedEventTimestamp(props) {
  const {
    event
  } = props;
  return /*#__PURE__*/_jsx(Small, {
    use: "help",
    display: "block",
    children: /*#__PURE__*/_jsx(FormattedDate, {
      date: event.occurredTimestamp
    })
  });
}